module.exports = __webpack_public_path__ + "static/img/bling.1f135892.png";